import { ageFromDob } from "../../../utils/clientAppUtils";
import { useClientAthlete } from "../../../context/ClientAthleteContext";
import { useSelector } from "react-redux";
import s from "../PatientPortal/clientApp.module.css";

function athleteChipLabel(athlete, myId) {
  if (athlete.is_self || String(athlete.id) === String(myId)) {
    return "Я";
  }
  return athlete.role_label || athlete.relation || athlete.full_name;
}

function athleteChipMeta(athlete) {
  const parts = [];
  if (athlete.membership_label) {
    parts.push(athlete.membership_label);
  } else if (athlete.trains && athlete.groups?.length) {
    parts.push(athlete.groups.map((g) => g.name).filter(Boolean).join(", "));
  } else if (athlete.trains) {
    parts.push("Занимается");
  } else {
    parts.push("Не занимается");
  }
  return parts.join(" · ");
}

function athletePortalHint(athlete, myId) {
  if (athlete.is_self || String(athlete.id) === String(myId)) return null;
  if (athlete.portal_activated) return "свой вход";
  if (athlete.portal_login_email) return "ждёт входа";
  return null;
}

export default function ClientChildSwitcher({ compact = false }) {
  const myId = useSelector((state) => state.auth.profile?.id);
  const { isParentMode, athletes, activeAthleteId, setActiveAthleteId } =
    useClientAthlete();

  if (!isParentMode || athletes.length <= 1) return null;

  return (
    <div className={compact ? s.childSwitcherCompact : s.childSwitcher}>
      {athletes.map((a) => {
        const age = ageFromDob(a.date_of_birth);
        const active = String(a.id) === String(activeAthleteId);
        const label = athleteChipLabel(a, myId);
        const meta = athleteChipMeta(a);
        const portalHint = athletePortalHint(a, myId);
        return (
          <button
            key={a.id}
            type="button"
            className={active ? s.childSwitcherBtnOn : s.childSwitcherBtn}
            onClick={() => setActiveAthleteId(a.id)}
            title={a.full_name}
          >
            <span>{label}</span>
            <em>
              {[meta, portalHint, age != null ? `${age} лет` : null]
                .filter(Boolean)
                .join(" · ")}
            </em>
          </button>
        );
      })}
    </div>
  );
}
